<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
    <!-- <template #header>
      <Tabs type="card" v-model="agent" @on-click="handleTab">
        <TabPane
          v-for="item in agentList"
          :key="item.id"
          :label="item.agent"
          :name="item.agent"
        />
      </Tabs>
    </template> -->
  </cTable>
</template>

<script>
import {
  getExceptionTracker,
  add,
  update,
  getDetails,
  del,
  getTurns,
  getExceptionProxy
} from "@/api/tracker/exception_tracker";
import { getStatus } from "@/api/tracker/status";
import cTable from "@/base/common/index.vue";
export default {
  name: "exceptionTracker",
  components: {
    cTable
  },
  methods: {
    handleTab(tab) {
      this.$refs["table"].agent = this.agent;
      this.$refs["table"].getList(1);
    }
  },
  data() {
    let statusList = [
        { label: this.$t("YES"), value: "YES" },
        { label: this.$t("NO"), value: "NO" }
      ],
      mappingList = [
        {
          label: this.$t("agentT") + this.$t("trajectory") + this.$t("exlType"),
          value: 1
        },
        {
          label: this.$t("agentT") + this.$t("trajectory") + this.$t("Remarks"),
          value: 2
        }
      ];
    return {
      agent: "TMS",
      agentList: [],
      methods: {
        list: async params => {
          // if (!this.agentList.length) {
          //   let res = await getExceptionProxy();
          //   this.agentList = res.data.payload;
          //   this.agent = res.data.payload[0].agent;
          //   this.$nextTick(() => {
          //     this.$refs["table"].handleResize();
          //   });
          // }
          params["agent"] = this.agent;
          return getExceptionTracker(params);
        },
        add,
        getStatus,
        update,
        del,
        getDetails,
        getTurns
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              console.log(row);
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "title cannot be empty",
                  trigger: "blur"
                }
              ],
              title_eng: [
                {
                  required: true,
                  message: "title_eng cannot be empty",
                  trigger: "blur"
                }
              ],
              exception_status: [
                {
                  required: true,
                  type: "array",
                  message: "exception_status cannot be empty",
                  trigger: "blur"
                }
              ],
              times: [
                {
                  required: true,
                  type: "number",
                  message: "times cannot be empty",
                  trigger: "blur"
                }
              ],
              call_times: [
                {
                  required: true,
                  type: "number",
                  message: "call_times cannot be empty",
                  trigger: "blur"
                }
              ],
              status: [
                {
                  required: true,
                  message: "status cannot be empty",
                  trigger: "blur"
                }
              ],
              sort: [
                {
                  required: true,
                  type: "number",
                  message: "sort cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [
            // { agent: 24 },
            { title: 24 },
            { title_eng: 24 },
            { exception_status: 24 },
            { times: 24 },
            { call_times: 24 },
            { sort: 24 },
            { turns: 24 },
            { on_shelve: 24 },
            { status: 24 }
          ],
          fields: [
            // {
            //   key: "agent",
            //   name: () => this.$t("agentName"),
            //   component: "Input",
            //   disabled: true,
            //   default: () => this.agent,
            //   placeholder() {
            //     return this.$t("enter") + this.$t("agentName");
            //   }
            // },
            {
              key: "title",
              name: () => this.$t("labelName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("labelName");
              }
            },
            {
              key: "title_eng",
              name: () => this.$t("English") + this.$t("labelName"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("English") + this.$t("labelName")
                );
              }
            },
            {
              key: "exception_status",
              name: () => this.$t("exception_status"),
              component: "Select",
              config: {
                label: "tracker_code",
                value: "tracker_code"
              },
              bind: {
                multiple: true
              },
              placeholder() {
                return this.$t("select") + this.$t("exception_status");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getStatus")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "times",
              name: () => this.$t("exceptionNum"),
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 1,
              placeholder() {
                return this.$t("enter") + this.$t("exceptionNum");
              }
            },
            {
              key: "call_times",
              name: () => this.$t("maxCall"),
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 1,
              placeholder() {
                return this.$t("enter") + this.$t("maxCall");
              }
            },
            {
              key: "sort",
              name: () => this.$t("sort"),
              component: "InputNumber",
              bind: {
                style: {
                  width: "100%"
                }
              },
              default: 1,
              placeholder() {
                return this.$t("enter") + this.$t("sort");
              }
            },
            {
              key: "turns",
              name: () => this.$t("AbnormalFlow"),
              component: "Select",
              config: {
                label: "name"
              },
              bind: {
                multiple: true
              },
              placeholder() {
                return this.$t("select") + this.$t("AbnormalFlow");
              },
              options: [],
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getTurns")
                  ).payload;
                  this.$forceUpdate();
                }
              }
            },
						{
						  key: "on_shelve",
						  name: () => this.$t("on_shelve"),
						  component: "Radio",
						  bind: {
						    border: true
						  },
						  options: statusList,
						  default: "YES"
						},
            {
              key: "status",
              name: () => this.$t("status"),
              component: "Radio",
              bind: {
                border: true
              },
              options: statusList,
              default: "YES"
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "warning",
                icon: "md-add"
              }
            }
          ],
          methods: {
            addFun() {
              this.getModal("add").setTitle(this.$t("add"));
              this.getModal("add").open();
            }
          }
        }
      },
      fields: [
        {
          type: "btns",
          width: 270,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error"
              }
            }
          ],

          methods: {
            async updateFun({ row }) {
              console.log(row);
              let res = await this.handleRequestMethods("getDetails", row.id);
              console.log("res", res);
              this.getModal("add").open(res.payload, function() {
                this.setTitle(this.$t("add"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("labelName") +
                  ":" +
                  row.title +
                  "?",
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then(res => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                }
              });
            }
          }
        },
        {
          name: () => this.$t("labelName"),
          key: "title",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("exception_status"),
          key: "exception_status",
          align: "center",
          minWidth: 125
        },
        {
          name: () => this.$t("exceptionNum"),
          key: "times",
          align: "center",
          minWidth: 100
        },
				{
				  name: () => this.$t("on_shelve"),
				  key: "on_shelve",
				  align: "center",
				  width: 100,
				  methods: {
				    render({ value }) {
				      return statusList.find(item => item.value == value).label;
				    }
				  }
				},
        {
          name: () => this.$t("status"),
          key: "status",
          align: "center",
          width: 100,
          methods: {
            render({ value }) {
              return statusList.find(item => item.value == value).label;
            }
          }
        },
        {
          name: () => this.$t("AbnormalFlow"),
          key: "turns",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("maxCall"),
          key: "call_times",
          width: 110
        },
        {
          name: () => this.$t("sort"),
          key: "sort",
          align: "center",
          width: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          width: 150
        }
      ]
    };
  },
  created() {
    // getExceptionProxy().then(res => {
    //   console.log(res);
    //   this.agentList = res.data.payload;
    //   this.agent = res.data.payload[0].agent;
    // });
  }
};
</script>

<style lang="scss" scoped></style>
